import { render, staticRenderFns } from "./market-notifications.vue?vue&type=template&id=231e5804&scoped=true&"
import script from "./market-notifications.vue?vue&type=script&lang=js&"
export * from "./market-notifications.vue?vue&type=script&lang=js&"
import style0 from "./market-notifications.vue?vue&type=style&index=0&id=231e5804&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231e5804",
  null
  
)

export default component.exports